<template>
  <div class="content-container accordion__wrapper">
    <button
      class="accordion__title"
      :class="isOpen ? 'accordion__title--open' : 'accordion__title--closed'"
      @click="toggleAccordion"
    >
      <span>{{ filterData.label }}</span>
      <span class="accordion__icon"></span>
    </button>
    <div
      class="accordion"
      :class="isOpen ? 'accordion--open' : 'accordion--closed'"
    >
      <FilterItem
        v-for="item in filterData.array"
        :key="item"
        :item="item"
        :category="filterData.category"
        :input-name="filterData.label"
        @input="handleChange"
      />
    </div>
  </div>
</template>

<script>
import FilterItem from '@/components/subcomponents/filters/FilterItem.vue'

export default {
  name: 'FilterAccordion',
  components: {
    FilterItem
  },
  props: {
    filterData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isOpen: this.filterData.accordionStatus
    }
  },
  methods: {
    handleChange (filterData) {
      const checked = filterData.checked
      const category = filterData.category
      const newData = {
        filter: filterData.value,
        category: filterData.category
      }

      if (checked === true) {
        switch (category) {
          case 'locationFilters':
            this.$store.commit('filters/addLocation', newData)
            break
          case 'departmentFilters':
            this.$store.commit('filters/addDepartment', newData)
            break
          case 'teamFilters':
            this.$store.commit('filters/addTeam', newData)
            break
        }
      } else {
        switch (category) {
          case 'locationFilters':
            this.$store.commit('filters/removeLocation', newData)
            break
          case 'departmentFilters':
            this.$store.commit('filters/removeDepartment', newData)
            break
          case 'teamFilters':
            this.$store.commit('filters/removeTeam', newData)
            break
        }
      }

      // Reset page number when clicking on filter
      this.$store.commit('pageNumber/setPage', 1)
    },
    toggleAccordion () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style scoped lang="scss">
@use 'mixins' as *;
@use 'variables';

.accordion {
  transition: 200ms ease max-height;
  overflow: hidden;

  &--open {
    max-height: 1000px;
  }

  &--closed {
    max-height: 0;
  }

  &__wrapper {
    &:last-of-type {
      padding-bottom: 1rem;
    }

    @include breakpoint-md {
      padding: 0;
    }
  }

  &__icon {
    display: block;
    position: relative;
    font-size: 1em;
    width: 1em;
    height: 1em;
    color: variables.$color-brand;

    &::before,
    &::after {
      content: '';
      position: absolute;
      background-color: currentColor;
      transition: transform 0.25s ease-out;
      transform-origin: center;
    }

    /* Vertical line */
    &::before {
      top: 0;
      left: 50%;
      width: 2px;
      height: 100%;
      margin-left: 0;
      transform: translateX(-50%);
    }

    /* horizontal line */
    &::after {
      top: 50%;
      left: 0;
      width: 100%;
      height: 2px;
      margin-top: 0;
      transform: translateY(-50%) scale(-1);
      // scale(-1) accounts for a bug in iOS where it rotates the other way if translateY(-50%) is applied
    }
  }

  &__title {
    align-items: center;
    text-transform: uppercase;
    font-size: 1.25em;
    background: none;
    border: 0;
    font-weight: bold;
    color: variables.$color-gray-5;
    display: flex;
    justify-content: space-between;
    width: 100%;
    text-align: left;
    padding: 0.75rem 0;
    outline: none;
    cursor: pointer;
    position: relative;

    &--open {
      .accordion__icon::before {
        transform: translateX(-50%) rotate(90deg);
      }

      .accordion__icon::after {
        transform: translateY(-50%) scale(-1) rotate(180deg);
      }
    }
  }
}
</style>
